import React from 'react';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import styles from './styles/PedidosExpedicao.module.css';
import Link from '../components/Link';
import PageTitle from '../components/PageTitle';

const EMPRESAS = [
  '14 - ESTOQUE BRUTOS',
  '31 - PRETO',
  '32 - GILLI',
  '33 - TONI',
  '34 - RICARDO',
  '35 - CLEBERSON',
  '36 - WILLIAM',
  '37 - EMANUEL',
  '38 - GERMANA',
  '39 - E-COMMERCE',
  '50 - SR-SP',
  '90 - SR-NE',
  'TD200 - TODESCHINI',
  'CG201 - CHAPECÓ GETÚLIO',
  'CS300 - CHAPECÓ SHOPPING',
  'CCS300 - CONSULTORAS CHAPECÓ SHOPPING',
  'BL301 - BELLA CITTÀ',
  'MS302 - MASTER',
  'PS400 - PRAÇA SÉ',
  'CMR411 - CONSULTORAS MOROM',
  'MR401 - MOROM',
  'CSC7029 - CONSULTORAS SC',
  'CTT410 - CONSULTORAS TRÊS TORRES',
  'TT410 - LOJA TRÊS TORRES',
  'EF46 - EFAPI',
  '19977 - SÃO JOSÉ'
];

const EMPRESA_ESTOQUE_BRUTOS = '14 - ESTOQUE BRUTOS';

const STATUS_OPTIONS = [
  'ABERTO',
  'EM PRODUÇÃO',
  'CONCLUÍDO',
  'RECUSADO',
  'CANCELADO'
];

const formatarDataHora = (data) => {
  if (!data) return null;

  const dataFormatada = new Date(data);
  if (Number.isNaN(dataFormatada.getTime())) return null;

  return dataFormatada.toLocaleString('pt-BR');
};

const obterPermissoes = () => {
  try {
    return JSON.parse(localStorage.getItem('permissoes')) || {};
  } catch (error) {
    return {};
  }
};

const obterEmpresasIniciais = () => {
  const permissoes = obterPermissoes();
  const filtroEmpresas = permissoes?.pedidos_expedicao?.filtro_empresas || permissoes?.['pedidos_expedicao.filtro_empresas'];

  if (filtroEmpresas === 'somente_14') return [EMPRESA_ESTOQUE_BRUTOS];
  if (filtroEmpresas === 'exceto_14') return EMPRESAS.filter((empresa) => empresa !== EMPRESA_ESTOQUE_BRUTOS);

  return [];
};

function PedidosExpedicao() {
  const [pedidos, setPedidos] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [imagemAmpliada, setImagemAmpliada] = useState(null);
  const [statusPendente, setStatusPendente] = useState(null);
  const [statusConfirmando, setStatusConfirmando] = useState(false);
  const [novoPedido, setNovoPedido] = useState({ empresa: '', codigo: '', quantidade: 1, anotacao: '' });
  const [filtros, setFiltros] = useState(() => ({
    empresa: obterEmpresasIniciais(),
    codigo: '',
    descricao: '',
    anotacao: '',
    status: 'ABERTO'
  }));
  const [empresaFiltroAberto, setEmpresaFiltroAberto] = useState(false);
  const codigoInputRef = useRef(null);

  const montarParams = () => {
    const params = new URLSearchParams();

    filtros.empresa.forEach((empresa) => params.append('empresa', empresa));

    ['codigo', 'descricao', 'anotacao', 'status'].forEach((campo) => {
      if (filtros[campo]) params.append(campo, filtros[campo]);
    });

    return params;
  };

  const carregarPedidos = async () => {
    const { data } = await axios.get('https://provin.ind.br/api/pedidos_expedicao', { params: montarParams() });
    setPedidos(data);
  };

  useEffect(() => {
    carregarPedidos();
  }, [filtros]); // eslint-disable-line react-hooks/exhaustive-deps

  const criarPedido = async () => {
    if (!novoPedido.empresa || novoPedido.quantidade < 1) return alert('Dados inválidos');
    await axios.post('https://provin.ind.br/api/pedidos_expedicao', novoPedido);
    setNovoPedido({ ...novoPedido, codigo: '', quantidade: 1, anotacao: '' });
    carregarPedidos();
    codigoInputRef.current?.focus();
  };

  const atualizarPedido = async (id, campo, valor) => {
    await axios.put(`https://provin.ind.br/api/pedidos_expedicao/${id}`, { [campo]: valor });
    carregarPedidos();
  };

  const solicitarAlteracaoStatus = (pedido, status) => {
    if (pedido.status === status) return;

    setStatusPendente({
      id: pedido.id,
      codigo: pedido.codigo,
      descricao: pedido.descr_longa,
      statusAtual: pedido.status || '-',
      novoStatus: status
    });
  };

  const confirmarAlteracaoStatus = async () => {
    if (!statusPendente || statusConfirmando) return;

    setStatusConfirmando(true);
    try {
      await atualizarPedido(statusPendente.id, 'status', statusPendente.novoStatus);
      setStatusPendente(null);
    } finally {
      setStatusConfirmando(false);
    }
  };

  const alternarEmpresaFiltro = (empresa) => {
    setFiltros((prev) => {
      const empresas = prev.empresa.includes(empresa)
        ? prev.empresa.filter((item) => item !== empresa)
        : [...prev.empresa, empresa];

      return {
        ...prev,
        empresa: empresas,
      };
    });
  };

  const marcarTodasEmpresas = () => {
    setFiltros((prev) => ({
      ...prev,
      empresa: [...EMPRESAS],
    }));
  };

  const limparEmpresas = () => {
    setFiltros((prev) => ({
      ...prev,
      empresa: [],
    }));
  };

  return (
    <div className={styles.body}>
      <Header />
      <Link redirectTo="/home" />

      <div className={styles.container}>
        <PageTitle src="/images/common/anotacao.ico" title="Pedidos" />

        <div className={styles.pageHeader}>
          <button className={styles.botaoNovo} onClick={() => setModalAberto(true)}>Novo Pedido</button>
        </div>

        <div className={styles.topo}>
          <div className={styles.filtrosTitulo}>
            <p>Filtros</p>
            <span>{pedidos.length} pedidos</span>
          </div>
          <div className={styles.filtros}>
            <div className={styles.empresaFiltro}>
              <button
                type="button"
                className={styles.empresaFiltroControle}
                onClick={() => setEmpresaFiltroAberto((aberto) => !aberto)}
              >
                <div>
                  Empresas
                  <span>{filtros.empresa.length ? `${filtros.empresa.length} selecionadas` : 'Todas'}</span>
                </div>
                <span className={`${styles.empresaFiltroSeta} ${empresaFiltroAberto ? styles.empresaFiltroSetaAberta : ''}`}>
                  v
                </span>
              </button>

              {empresaFiltroAberto && (
                <div className={styles.empresaFiltroMenu}>
                  <div className={styles.empresaFiltroAcoes}>
                    <button
                      type="button"
                      onClick={marcarTodasEmpresas}
                      disabled={filtros.empresa.length === EMPRESAS.length}
                    >
                      Marcar tudo
                    </button>
                    <button
                      type="button"
                      onClick={limparEmpresas}
                      disabled={filtros.empresa.length === 0}
                    >
                      Limpar
                    </button>
                  </div>
                  <ul className={styles.empresaLista}>
                    {EMPRESAS.map(emp => (
                      <li key={emp}>
                        <label>
                          <input
                            type="checkbox"
                            checked={filtros.empresa.includes(emp)}
                            onChange={() => alternarEmpresaFiltro(emp)}
                          />
                          <span>{emp}</span>
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <input placeholder="Código" onChange={e => setFiltros({ ...filtros, codigo: e.target.value })} className={styles.input} />
            <input placeholder="Descrição" onChange={e => setFiltros({ ...filtros, descricao: e.target.value })} className={styles.input} />
            <input placeholder="Anotação" onChange={e => setFiltros({ ...filtros, anotacao: e.target.value })} className={styles.input} />
            <select onChange={e => setFiltros({ ...filtros, status: e.target.value })} className={styles.input} defaultValue={filtros.status}>
              <option value="">Todos os Status</option>
              {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>

        <div className={styles.pedidosLista}>
          {pedidos.map(p => (
            <div className={styles.pedidoCard} key={p.id}>
              <div className={styles.pedidoImagemBox}>
                <button
                  type="button"
                  className={styles.imagemBotao}
                  onClick={() => setImagemAmpliada({
                    codigo: p.codigo,
                    descricao: p.descr_longa,
                    src: `https://provin.ind.br/api/imagem_produto/${p.codigo}`
                  })}
                >
                  <img
                    className={styles.thumb}
                    src={`https://provin.ind.br/api/imagem_produto/${p.codigo}`}
                    alt=""
                    onError={(e) => { e.target.onerror = null; e.target.src = 'images/produtos/sem_imagem.jpg'; }}
                  />
                </button>
              </div>

              <div className={styles.pedidoConteudo}>
                <div className={styles.pedidoTopo}>
                  <div className={styles.pedidoIdentificacao}>
                    <strong>#{p.id}</strong>
                    <span className={styles.codigoCell}>{p.codigo || '-'}</span>
                    <span className={styles.statusBadge}>{p.status || '-'}</span>
                  </div>
                  <div className={styles.pedidoDataCriacao}>
                    <span>Criação: {formatarDataHora(p.data_criacao) || ''}</span>
                  </div>
                </div>

                <div className={styles.pedidoDescricao}>
                  <strong>{p.descr_longa || '-'}</strong>
                  <span className={styles.empresaCell}>{p.empresa || '-'}</span>
                </div>

                <div className={styles.pedidoCampos}>
                  <div className={styles.campoCompacto}>
                    <span>Qtd</span>
                    <QuantidadeInput
                      pedido={p}
                      onAtualizar={atualizarPedido}
                    />
                  </div>
                  <div className={styles.campoCompacto}>
                    <span>Estoque</span>
                    <strong className={styles.estoqueCell}>{p.estoque ?? '-'}</strong>
                  </div>
                  <div className={styles.anotacaoCampo}>
                    <span>Anotação</span>
                    <textarea
                      defaultValue={p.anotacao || ''}
                      onBlur={e => atualizarPedido(p.id, 'anotacao', e.target.value)}
                      className={styles.editInput}
                      rows={2}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.statusPanel}>
                <span>Alterar status</span>
                <div className={styles.pedidoDataAtualizacao}>
                  <span>Última atualização: {formatarDataHora(p.dt_alteracao_status) || 'Nunca'}</span>
                </div>

                <div className={styles.statusRadioGroup}>
                  {STATUS_OPTIONS.map(status => (
                    <label key={status} className={p.status === status ? styles.statusRadioAtivo : ''}>
                      <input
                        type="radio"
                        name={`status-${p.id}`}
                        value={status}
                        checked={p.status === status}
                        onChange={() => solicitarAlteracaoStatus(p, status)}
                      />
                      <span>{status}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {modalAberto && (
          <div className={styles.modalOverlay}>
            <div className={styles.modal}>
              <h3>Novo Pedido</h3>
              <select
                value={novoPedido.empresa}
                onChange={e => setNovoPedido({ ...novoPedido, empresa: e.target.value })}
                className={styles.input}
              >
                <option value="">Selecione a Empresa</option>
                {EMPRESAS.map(emp => <option key={emp}>{emp}</option>)}
              </select>
              <input
                ref={codigoInputRef}
                placeholder="Código (opcional)"
                value={novoPedido.codigo}
                onChange={e => setNovoPedido({ ...novoPedido, codigo: e.target.value })}
                className={styles.input}
              />
              <input
                type="number"
                min={1}
                value={novoPedido.quantidade}
                onChange={e => setNovoPedido({ ...novoPedido, quantidade: parseInt(e.target.value) })}
                className={styles.input}
              />
              <input
                placeholder="Anotação (opcional)"
                value={novoPedido.anotacao}
                onChange={e => setNovoPedido({ ...novoPedido, anotacao: e.target.value })}
                className={styles.input}
              />
              <div className={styles.modalAcoes}>
                <button onClick={criarPedido}>Salvar</button>
                <button onClick={() => setModalAberto(false)}>Fechar</button>
              </div>
            </div>
          </div>
        )}

        {statusPendente && (
          <div className={styles.statusModalOverlay} role="dialog" aria-modal="true" aria-label="Confirmar alteração de status">
            <div className={styles.statusModal}>
              <div className={styles.statusModalCabecalho}>
                <span>Confirmar alteração</span>
                <h3>{statusPendente.novoStatus}</h3>
              </div>

              <div className={styles.statusModalResumo}>
                <strong>Pedido #{statusPendente.id}</strong>
                <span>{statusPendente.codigo || '-'}</span>
                <p>{statusPendente.descricao || '-'}</p>
              </div>

              <div className={styles.statusModalFluxo}>
                <span>{statusPendente.statusAtual}</span>
                <strong>para</strong>
                <span>{statusPendente.novoStatus}</span>
              </div>

              <div className={styles.statusModalAcoes}>
                <button type="button" onClick={() => setStatusPendente(null)} disabled={statusConfirmando}>
                  Cancelar
                </button>
                <button type="button" onClick={confirmarAlteracaoStatus} disabled={statusConfirmando}>
                  {statusConfirmando ? 'Salvando...' : 'Confirmar'}
                </button>
              </div>
            </div>
          </div>
        )}

        {imagemAmpliada && (
          <div
            className={styles.imagemModalOverlay}
            role="dialog"
            aria-modal="true"
            aria-label="Imagem do produto"
            onClick={() => setImagemAmpliada(null)}
          >
            <button
              type="button"
              className={styles.imagemModalFechar}
              onClick={() => setImagemAmpliada(null)}
            >
              Fechar
            </button>
            <div className={styles.imagemModalConteudo} onClick={(e) => e.stopPropagation()}>
              <img
                src={imagemAmpliada.src}
                alt={imagemAmpliada.descricao || imagemAmpliada.codigo || 'Produto'}
                onError={(e) => { e.target.onerror = null; e.target.src = 'images/produtos/sem_imagem.jpg'; }}
              />
              <div>
                <strong>{imagemAmpliada.codigo || '-'}</strong>
                <span>{imagemAmpliada.descricao || '-'}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// Função para armazenar a quantidade do pedido localmente, e enviar requisição apenas no onBlur do input (para corrigir os erros de bugs/travamentos ao digitar a quantidade)
function QuantidadeInput({ pedido, onAtualizar }) {
  const [valor, setValor] = useState(pedido.quantidade);

  useEffect(() => {
    setValor(pedido.quantidade);
  }, [pedido.quantidade]);

  return (
    <input
      type="number"
      min="0"
      value={valor}
      onChange={e => setValor(e.target.value)}
      onBlur={() => onAtualizar(pedido.id, 'quantidade', valor)}
      className={`${styles.editInput} ${styles.quantidadeInput}`}
    />
  );
}

export default PedidosExpedicao;
